// Single source of truth for nav icons. Replaces server-rendered icons (which
// have per-locale Shopify cache delays). Runs on both EN and HE the same way.
(function () {
  if (typeof window === 'undefined') return;

  // ===== Icon definitions (Lucide-style stroke SVGs) =====
  const I = {
    home:      '<path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>',
    ring:      '<circle cx="12" cy="14" r="6"/><path d="m9 8 1.5-4h3L15 8"/>',
    earring:   '<circle cx="8" cy="6" r="1.5" fill="currentColor"/><path d="M8 8v6a4 4 0 0 0 4 4 4 4 0 0 0 4-4V8"/><circle cx="16" cy="6" r="1.5" fill="currentColor"/>',
    bracelet:  '<ellipse cx="12" cy="12" rx="9" ry="6"/><circle cx="12" cy="6" r="1.4" fill="currentColor"/>',
    necklace:  '<path d="M4 5c0 5 3.5 9 8 9s8-4 8-9"/><path d="m10 14 2 4 2-4"/>',
    sparkles:  '<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.582a.5.5 0 0 1 0 .962L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>',
    diamond:   '<path d="M12 2 4 9 12 22 20 9Z"/><line x1="4" y1="9" x2="20" y2="9"/><line x1="8" y1="9" x2="12" y2="2"/><line x1="16" y1="9" x2="12" y2="2"/><line x1="8" y1="9" x2="12" y2="22"/><line x1="16" y1="9" x2="12" y2="22"/>',
    leaf:      '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19.2 2.96a1 1 0 0 1 1.8.4c1 5-1 13-9 17-3.6 1.8-7.6 1.4-9.6.4"/><path d="M2 22s5-4 8.5-9.5"/>',
    flower:    '<circle cx="12" cy="12" r="2.5"/><path d="M12 9.5V5M12 14.5V19M9.5 12H5M14.5 12H19M10.2 10.2 7 7M13.8 13.8l3.2 3.2M10.2 13.8 7 17M13.8 10.2 17 7"/>',
    crown:     '<path d="m2 4 3 12h14l3-12-6 7-4-7-4 7z"/><path d="M5 21h14"/>',
    star:      '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
    book:      '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>',
    newspaper: '<path d=\"M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2\"/><path d=\"M18 14h-8M15 18h-5M10 6h8v4h-8z\"/>',
    mail:      '<rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>',
    ruler:     '<path d="M21.3 8.7 8.7 21.3a2 2 0 0 1-2.8 0L2.7 18.1a2 2 0 0 1 0-2.8L15.3 2.7a2 2 0 0 1 2.8 0l3.2 3.2a2 2 0 0 1 0 2.8z"/><path d="m7 17 2-2M11 13l2-2M15 9l2-2"/>',
    refund:    '<path d="M3 12a9 9 0 1 0 9-9"/><path d="M3 4v5h5"/>',
    document:  '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/>',
    shield:    '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
    user:      '<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
    package:   '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>',
    'arrow-left': '<line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>',
    snowflake: '<line x1="2" y1="12" x2="22" y2="12"/><line x1="12" y1="2" x2="12" y2="22"/><path d="m20 16-4-4 4-4"/><path d="m4 8 4 4-4 4"/><path d="m16 4-4 4-4-4"/><path d="m8 20 4-4 4 4"/>',
    truck:     '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>',
  };

  function wrap(svgInner) {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + svgInner + '</svg>';
  }

  // ===== ONE-PLACE-CHANGE icon mapping =====
  // Determine icon for a given anchor element by url + decoded text.
  function pickIcon(href, text) {
    const u = (href || '').toLowerCase();
    const t = (text || '').trim().toLowerCase();
    // URL substring matches (English handles)
    if (u.endsWith('/') && (u === '/' || u.endsWith('/he-il/') || u.endsWith('/en/'))) return 'home';
    if (u.includes('/collections/white-pro'))   return 'diamond';
    if (u.includes('/collections/white'))       return 'flower';
    if (u.includes('/collections/stone'))       return 'leaf';
    if (u.includes('/collections/all'))         return 'sparkles';
    if (u.endsWith('/collections'))             return 'crown';
    if (u.includes('/policies/refund'))         return 'refund';
    if (u.includes('/policies/terms'))          return 'document';
    if (u.includes('/policies/privacy'))        return 'shield';
    if (u.includes('/orders') || u.includes('/account')) return 'package';
    if (u.includes('/apps/track') || u.includes('package-tracking')) return 'truck';
    if (u.includes('contact'))                  return 'mail';
    if (u.includes('/blogs'))                   return 'newspaper';
    // URL substring matches (Hebrew handles, URL-encoded)
    if (u.includes('%d7%a2%d7%92%d7%99%d7%9c%d7%99%d7%9d')) return 'earring';   // עגילים
    if (u.includes('%d7%98%d7%91%d7%a2%d7%95%d7%aa'))       return 'ring';      // טבעות
    if (u.includes('%d7%a6%d7%9e%d7%99%d7%93%d7%99%d7%9d')) return 'bracelet';  // צמידים
    if (u.includes('%d7%a9%d7%a8%d7%a9%d7%a8%d7%90%d7%95%d7%aa')) return 'necklace'; // שרשראות
    if (u.includes('%d7%94%d7%a0%d7%9e%d7%9b%d7%a8%d7%99%d7%9d-%d7%91%d7%99%d7%95%d7%aa%d7%a8')) return 'star'; // הנמכרים-ביותר
    if (u.includes('%d7%a7%d7%a6%d7%aa-%d7%a2%d7%9c%d7%99%d7%a0%d7%95')) return 'book'; // קצת-עלינו (Our Story)
    if (u.includes('%d7%9e%d7%93%d7%a8%d7%99%d7%9a-%d7%9e%d7%99%d7%93%d7%95%d7%aa')) return 'ruler'; // מדריך-מידות
    if (u.includes('%d7%90%d7%99%d7%9a-%d7%a9%d7%95%d7%9e%d7%a8%d7%99%d7%9d')) return 'sparkles'; // איך-שומרים (Care)
    // Text fallbacks (EN + HE)
    if (t === 'home' || t === 'דף הבית')                 return 'home';
    if (t === 'earrings' || t === 'עגילים')              return 'earring';
    if (t === 'rings' || t === 'טבעות')                  return 'ring';
    if (t === 'bracelets' || t === 'צמידים')             return 'bracelet';
    if (t === 'necklaces' || t === 'שרשראות')            return 'necklace';
    if (t === 'all jewelry' || t === 'כל התכשיטים')      return 'sparkles';
    if (t === 'special collections' || t === 'קולקציות מיוחדות') return 'crown';
    if (t === 'bestsellers' || t === 'הנמכרים ביותר')    return 'star';
    if (t === 'our story' || t === 'הסיפור שלנו')        return 'book';
    if (t === 'blog' || t === 'בלוג')                    return 'newspaper';
    if (t === 'contact us' || t === 'צרו קשר')           return 'mail';
    if (t === 'size guide' || t === 'מדריך מידות')       return 'ruler';
    if (t === 'jewelry care guide' || t === 'איך שומרים על תכשיטים?') return 'sparkles';
    if (t === 'refund policy' || t === 'מדיניות החזרות') return 'refund';
    if (t === 'terms of service' || t === 'תקנון')       return 'document';
    if (t === 'my orders' || t === 'ההזמנות שלי')        return 'package';
    if (t === 'track order' || t === 'מעקב הזמנה' || t === 'מעקב אחר הזמנה' || t === 'מעקב משלוח') return 'truck';
    if (t === 'back to store' || t === 'בחזרה לחנות')    return 'arrow-left';
    if (t === 'white & festive' || t === 'לבן וחגיגי')   return 'diamond';
    if (t === 'delicate & beautiful' || t === 'עדין ויפה') return 'flower';
    if (t === 'natural & bold' || t === 'טבעי ובולט')    return 'leaf';
    return null;
  }

  function buildIconSpan(iconName) {
    const inner = I[iconName];
    if (!inner) return null;
    const span = document.createElement('span');
    span.className = 'menu-link-icon';
    span.setAttribute('aria-hidden', 'true');
    span.dataset.navIconAuto = '1';
    span.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;margin-inline-end:0.6rem;opacity:0.7;flex-shrink:0;vertical-align:middle;';
    span.innerHTML = wrap(inner);
    return span;
  }

  function process() {
    // Select all menu links across drawer, dropdown, mega-menu
    const selectors = [
      '.menu-drawer__menu-item',
      '.header__inline-menu a',
      '.list-menu__item',
      '.mega-menu__link',
    ];
    const items = new Set();
    selectors.forEach(s => document.querySelectorAll(s).forEach(el => items.add(el)));
    items.forEach(el => {
      // Get href: anchors have href, summaries have href on a parent or via menu_link
      let href = el.getAttribute('href') || '';
      // Get the visible text label (strip child SVGs / chevrons)
      let text = el.textContent || '';
      // Pick icon
      const icon = pickIcon(href, text);
      if (!icon) return;
      // Remove any prior server-rendered or JS-injected icon
      el.querySelectorAll('.menu-link-icon').forEach(s => s.remove());
      const span = buildIconSpan(icon);
      if (span) {
        // Insert at the start of the link
        el.insertBefore(span, el.firstChild);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', process);
  } else {
    process();
  }
  // Re-run on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', process);
  // Safety retry for late-mount cases
  setTimeout(process, 800);
})();
